import React from 'react';
import { Helmet } from 'react-helmet';

function Money_Transfer_Seo() {
    return (
        <div>
            <Helmet>
                <title>Money Transfer to Nigeria | FinestPay</title>
                <meta name="description" content="Money Transfer to Nigeria was never this simple. Just download our app and you are ready to transfer money. Our automated integrations makes it quick and swift to transfer money and money is with receiver in minutes. Join Today." />
                <meta property="og:title" content="Money Transfer to Nigeria | FinestPay" />
                <meta property="og:description" content="Money Transfer to Nigeria was never this simple. Just download our app and you are ready to transfer money. Our automated integrations makes it quick and swift to transfer money and money is with receiver in minutes. Join Today." />
                <meta property="og:image" content="https://finestpay.co.uk/assets/img/FinestPay-icon.png" /> {/* Replace with actual image URL */}
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://finestpay.co.uk/money-transfer" />
            </Helmet>
        </div>
    )
}

export default Money_Transfer_Seo
